
import logo from '../Assets/laja-logo.png'
import {Link, NavLink} from "react-router-dom";

function Header() {
  return (
    <>
    
    <a href="#main" className="skip-link">Skip to main content</a>

<div className="utility-bar">
  <div className="container">
    <div className="utility-left">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone h-4 w-4"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
      <Link to="tel:0519201790" style={{marginRight:'15px'}}>051-9201790</Link>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail h-4 w-4"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
      <Link to="mailto:contact@laja.gov.pk">contact@laja.gov.pk</Link>
      {/* <a href="#">RTI</a>
      <a href="#">Tenders</a> */}
    </div>
    <div className="utility-right">
      <div className="social-row-top" aria-label="Social media">
          <Link to="https://www.facebook.com/profile.php?id=61586185169804" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="currentColor" style={{color:'#fff', background:'blue'}}><path d="M14 9h3V6h-3c-1.7 0-3 1.3-3 3v2H9v3h2v7h3v-7h2.5l.5-3H14V9z"/></svg></Link>
          <Link to="https://x.com/lajapak" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" style={{color:'#fff', background:'black'}}><path d="M4 4l16 16M20 4L4 20" strokeWidth="2.6"/></svg></Link>
          <Link to="https://www.linkedin.com/company/110822913/admin/page-posts/published/" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" style={{color:'#fff', background:'#0a66c2'}}><path d="M8 10v8M8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM12 10v8M12 13c0-2 1.2-3 3-3s3 1 3 3v5M15 10c-1.8 0-3 1-3 3" strokeWidth="2.6"/></svg></Link>
          <Link to="https://www.youtube.com/@lajapakistan/videos" target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 24 24" fill="currentColor" style={{color:'#fff', background:'red'}}><path d="M21 8s0-2-2-2H5c-2 0-2 2-2 2v8s0 2 2 2h14c2 0 2-2 2-2V8zM10 9l5 3-5 3V9z"/></svg></Link>
        </div>
     
    </div>
  </div>
</div>
<header className="masthead">
  <div className="container">
    <div className="masthead__emblem">
      <img src={logo} alt="Logo" />
    </div>
    <div className="masthead__title">
      <span className="masthead__eyebrow">The Government of Pakistan &middot; Ministry of Law & Justice</span>
      <h1>Legal Aid &amp; Justice Authority</h1>
      <p className="masthead__tagline">Equal access to justice, for every citizen of pakistan.</p>
    </div>
    <div className="masthead__cta">
      <Link className="btn btn--gold" to="/application">Get Legal Aid</Link>
      {/* <a href="complaint.html" className="btn btn--gold">Get Legal Aid</a> */}
    </div>
  </div>
</header>
<nav className="primary-nav" aria-label="Primary">
  <div className="container">
    {/* <input type="checkbox" id="navToggle" className="nav-toggle"> */}
    <label forhtml="navToggle" className="nav-toggle-label">Menu</label>
    <ul>
      <li><NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>Home</NavLink></li>
      <li><NavLink to="/about" className={({ isActive }) => isActive ? "active" : ""}>About Us</NavLink></li>
      <li><NavLink to="/bog" className={({ isActive }) => isActive ? "active" : ""}>Board of Governors</NavLink></li>
      <li><NavLink to="/news" className={({ isActive }) => isActive ? "active" : ""}>News & Events</NavLink></li>
      <li><NavLink to="/downloads" className={({ isActive }) => isActive ? "active" : ""}>Downloads</NavLink></li>
      <li><NavLink to="/career" className={({ isActive }) => isActive ? "active" : ""}>Careers</NavLink></li>
      <li><NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>Contact Us</NavLink></li>
    </ul>
  </div>
</nav></>
  );
}

export default Header;
